import { render, staticRenderFns } from "./tdb-header.vue?vue&type=template&id=5b55bdea&scoped=true"
import script from "./tdb-header.vue?vue&type=script&lang=js"
export * from "./tdb-header.vue?vue&type=script&lang=js"
import style0 from "./tdb-header.vue?vue&type=style&index=0&id=5b55bdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55bdea",
  null
  
)

export default component.exports